<div [formGroup]="sectionDialogCoreForm">
  <mat-form-field appearance="fill" fxFill class="dashboard-section-dialog__content__left-input">
    <mat-label>Section Name</mat-label>
    <input matInput formControlName="sectionName" />
    <mat-error *ngIf="sectionName.hasError('required')"> Section name is <strong>required</strong></mat-error>
  </mat-form-field>
  <mat-form-field appearance="fill" fxFill>
    <mat-label>Section Type</mat-label>
    <mat-select [value]="selectedSection?.type" [formControl]="type">
      <mat-option *ngFor="let type of types" [value]="type">{{ type }}</mat-option>
    </mat-select>
  </mat-form-field>
  <div>
    <mat-tab-group
      mat-align-tabs="end"
      #languageTabs
      (selectedTabChange)="selectTemplateLanguage($event)"
      [disablePagination]="true"
      [selectedIndex]="selectedLanguage?.tabIndex"
    >
      <mat-tab *ngFor="let language of supportedLanguages" [label]="language.name">
        <ng-container *ngTemplateOutlet="tabContent"></ng-container>
      </mat-tab>
    </mat-tab-group>
    <ng-template #tabContent>
      <div formArrayName="translations" *ngFor="let item of translations?.controls; let i = index">
        <mat-form-field
          [formGroupName]="i"
          *ngIf="
            item.get('language').value === selectedLanguage.code &&
            item.get('identifier').value === SECTION_TITLE_IDENTIFIER
          "
          fxFill
        >
          <input matInput formControlName="translation" placeholder="Section Title" />
          <mat-error
            *ngIf="
              item.get('identifier').value === SECTION_TITLE_IDENTIFIER && item.get('translation').hasError('maxlength')
            "
          >
            Section title should have
            <strong>at most {{ item.get('translation').errors?.maxlength.requiredLength }}</strong> characters
          </mat-error>
        </mat-form-field>
      </div>
    </ng-template>
  </div>
  <div>
    <mat-tab-group
      mat-align-tabs="end"
      animationDuration="0ms"
      #languageTabsEditor
      (selectedTabChange)="selectTemplateLanguage($event)"
      [disablePagination]="true"
      [selectedIndex]="selectedLanguage?.tabIndex"
    >
      <mat-tab *ngFor="let language of supportedLanguages" [label]="language.name">
        <ng-template matTabContent>
          <div formArrayName="translations" *ngFor="let item of translations?.controls; let i = index">
            <div
              class="dashboard-section-dialog__content__left-text-editor"
              [formGroupName]="i"
              *ngIf="
                item.get('language').value === selectedLanguage?.code &&
                item.get('identifier').value === SECTION_TEXT_IDENTIFIER
              "
              fxFill
            >
              <label class="dashboard-section-dialog__content__left-text-editor-label">Section Text</label>
              <editor formControlName="translation" [init]="tinymceInitConfig"></editor>
              <mat-error
                *ngIf="
                  item.get('identifier').value === SECTION_TEXT_IDENTIFIER &&
                  item.get('translation').hasError('maxlength')
                "
              >
                Section text should have
                <strong>at most {{ item.get('translation').errors?.maxlength.requiredLength }}</strong>
                characters
              </mat-error>
            </div>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
